(function (global, factory) {
    if (typeof define === "function" && define.amd) {
        define(['exports', 'react', 'lodash.omit'], factory);
    } else if (typeof exports !== "undefined") {
        factory(exports, require('react'), require('lodash.omit'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.react, global.lodash);
        global.ReactCursorPosition = mod.exports;
    }
})(this, function (exports, _react, _lodash) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _react2 = _interopRequireDefault(_react);

    var _lodash2 = _interopRequireDefault(_lodash);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    exports.default = _react2.default.createClass({

        displayName: 'ReactCursorPosition',

        getInitialState: function getInitialState() {
            return {
                elementOffset: {
                    x: 0,
                    y: 0
                },
                cursorPosition: {
                    x: 0,
                    y: 0,
                    isOutside: true
                }
            };
        },


        propTypes: {
            className: _react.PropTypes.string,
            mapChildProps: _react.PropTypes.func,
            onCursorPositionChanged: _react.PropTypes.func,
            shouldDecorateChildren: _react.PropTypes.bool,
            style: _react.PropTypes.object
        },

        getDefaultProps: function getDefaultProps() {
            return {
                mapChildProps: function mapChildProps(props) {
                    return props;
                },
                onCursorPositionChanged: function onCursorPositionChanged() {},
                shouldDecorateChildren: true
            };
        },
        onMouseEnter: function onMouseEnter(e) {
            var elementOffset = this.getDocumentRelativeElementOffset(e.currentTarget);
            this.setState({ elementOffset: elementOffset });
        },
        onMouseLeave: function onMouseLeave() {
            var cursorPosition = Object.assign({}, this.state.cursorPosition, { isOutside: true });
            this.setState({
                cursorPosition: cursorPosition
            });
            this.props.onCursorPositionChanged(cursorPosition);
        },
        getDocumentRelativeElementOffset: function getDocumentRelativeElementOffset(el) {
            var rootEl = this.getRootOfEl(el);

            var _rootEl$getBoundingCl = rootEl.getBoundingClientRect(),
                docLeft = _rootEl$getBoundingCl.left,
                docTop = _rootEl$getBoundingCl.top;

            var _el$getBoundingClient = el.getBoundingClientRect(),
                elLeft = _el$getBoundingClient.left,
                elTop = _el$getBoundingClient.top;

            return {
                x: Math.abs(docLeft) + elLeft,
                y: Math.abs(docTop) + elTop
            };
        },
        getRootOfEl: function getRootOfEl(el) {
            if (el.parentElement) {
                return this.getRootOfEl(el.parentElement);
            }
            return el;
        },
        onMouseMove: function onMouseMove(e) {
            var cursorPosition = this.getDocumentRelativeCursorPosition(e);
            var elementOffset = this.state.elementOffset;
            var offsetCursorPosition = Object.assign({ isOutside: false }, this.getOffsetCursorPosition(cursorPosition, elementOffset));

            this.setState({ cursorPosition: offsetCursorPosition });
            this.props.onCursorPositionChanged(offsetCursorPosition);
        },
        getDocumentRelativeCursorPosition: function getDocumentRelativeCursorPosition(event) {
            return {
                x: event.pageX,
                y: event.pageY
            };
        },
        getOffsetCursorPosition: function getOffsetCursorPosition(documentRelativeCursorPosition, elementOffset) {
            var cursorX = documentRelativeCursorPosition.x,
                cursorY = documentRelativeCursorPosition.y;
            var offsetX = elementOffset.x,
                offsetY = elementOffset.y;


            return {
                x: cursorX - offsetX,
                y: cursorY - offsetY
            };
        },
        isReactComponent: function isReactComponent(reactElement) {
            return typeof reactElement.type === 'function';
        },
        shouldDecorateChild: function shouldDecorateChild(child) {
            return this.isReactComponent(child) && this.props.shouldDecorateChildren;
        },
        decorateChild: function decorateChild(child, props) {
            return (0, _react.cloneElement)(child, props);
        },
        renderChildrenWithProps: function renderChildrenWithProps(children, props) {
            var _this = this;

            return _react.Children.map(children, function (child) {
                return _this.shouldDecorateChild(child) ? _this.decorateChild(child, props) : child;
            });
        },
        render: function render() {
            var _props = this.props,
                children = _props.children,
                className = _props.className,
                mapChildProps = _props.mapChildProps,
                style = _props.style;

            var childProps = Object.assign({}, mapChildProps({ cursorPosition: this.state.cursorPosition }), (0, _lodash2.default)(this.props, ['children', 'className', 'mapChildProps', 'onCursorPositionChanged', 'shouldDecorateChildren', 'style']));

            return _react2.default.createElement(
                'div',
                {
                    className: className,
                    onMouseMove: this.onMouseMove,
                    onMouseEnter: this.onMouseEnter,
                    onMouseLeave: this.onMouseLeave,
                    style: style
                },
                this.renderChildrenWithProps(children, childProps)
            );
        }
    });
});


//////////////////
// WEBPACK FOOTER
// ./~/react-cursor-position/dist/ReactCursorPosition.js
// module id = 667
// module chunks = 0